import { createSelector } from '@reduxjs/toolkit';

const selectRoot = state => state?.lastValidEBPMSEventsState;
export const selectEbpmsLastValidMessage = createSelector(selectRoot, state => state?.lastValidEBPMSEvents ?? false);
